<template>
  <div class="anonymous-feedback-form">
    <h3>
      {{ t('title') }}
    </h3>
    <h5>
      {{ t('text', { email : email}) }}
    </h5>
    <TheButton
      class="max-w-[343px]"
      is-active
      @click="closeModal"
    >
      {{ t('close') }}
    </TheButton>
    <TheButton
      style-type="secondary"
      class="success-button mt-[20px] max-w-[343px]"
      @click="copyToClipboard"
    >
      {{copyButtonText}}
    </TheButton>
  </div>
</template>

<script lang="ts">
export default {
  name: 'TheAnonumousUserFeedbackForm',
};
</script>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import TheButton from '@/components/atoms/TheButton/index.vue';
import {ref} from "vue";

const emits = defineEmits(['sendMail', 'close']);
const { t } = useI18n({
  useScope: 'local',
  messages: {
    ru: {
      title: 'Напишите нам письмо',
      text: 'Если Вы еще не зарегистрировались, то отправьте нам на почту ({email}) площадь объекта и город в котором он находится, и мы свяжемся с Вами в ближайшее время. Или задайте любой интересующий Вас вопрос.',
      close: 'Закрыть',
      copy: 'Скопировать адрес почты',
      copied: 'Скопировано',
    },
    en: {
      title: 'Write us a letter',
      text: 'If you haven\'t registered yet, please email us ({email}) the property\'s area and city, and we\'ll contact you shortly. Or ask any questions you may have.',
      close: 'Close',
      copy: 'Copy email address',
      copied: 'Copied',
    },
    es: {
      title: 'Escríbenos una carta',
      text: 'Si aún no se ha registrado, envíenos un correo electrónico ({email}) con la zona y ciudad de la propiedad y nos pondremos en contacto con usted en breve. También puede hacernos cualquier pregunta.',
      close: 'Cerca',
      copy: 'Copiar dirección de correo electrónico',
      copied: 'Copiado',
    },
  },
});
const copyButtonText = ref<string>(t('copy'));
const email = 'info@id-home.org';

const closeModal = () => {
  emits('close');
}

async function copyToClipboard() {
  await navigator.clipboard.writeText('info@id-home.org');
  copyButtonText.value = t('copied');
}
</script>

<style scoped lang="scss">
.anonymous-feedback-form {
  width: 400px;

  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    font-family: 'Circe Th', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 31px;
    text-align: center;
    color: #161e57;
    margin-bottom: 10px;
  }

  h5 {
    text-align: center;
    margin-bottom: 50px;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;

  }

  .success-button {
    font-family: 'Circe Rg', sans-serif !important;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
